<template>
  <b-container>
    <b-row>
      <b-col />
      <b-col>
        <ValidationObserver
          ref="observer"
          v-slot="{ invalid }"
          class="tsny_form"
        >
          <logo-full />
          <b-row>
            <b-col>
              <BTextInputValidated
                :rules="{
                  required: true,
                  min: 8,
                  regex: passwordRegex
                }"
                type="password"
                label="Password"
                name="confirm"
                v-model="password"
                @keyup.enter.native="resetPassword"
              >
                <div class="password_validators">
                  <b-row>
                    <b-col>
                      <span
                        class="tsny_field_error-text"
                        :class="[lengthError ? 'text-danger' : 'text-success']"
                      >
                        Password is at least 8 characters long
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span
                        class="tsny_field_error-text"
                        :class="[regexError ? 'text-danger' : 'text-success']"
                      >
                        Contains at least one capital, lowercase, and number
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </BTextInputValidated>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BTextInputValidated
                rules="password:confirm"
                type="password"
                label="Confirm Password"
                v-model="confirmPassword"
                @keyup.enter.native="resetPassword"
              />
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-button
              v-if="showResetButton"
              class="tsny_button"
              :disabled="invalid"
              @click="resetPassword()"
              >RESET PASSWORD</b-button
            >
            <p v-if="resetSuccess" class="tsny_status-text">
              The password for {{ email }} has been successfully reset. You will
              be redirected back to the login screen in
              {{ redirectCount }} seconds
            </p>
            <p v-if="resetError" class="tsny_status-text">
              There was an issue resetting your password. Please try again in a
              few minutes
            </p>
          </b-row>
        </ValidationObserver>
      </b-col>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script>
import ExternalRestService from "../../services/rest/services/ExternalRestService";
import StoreConstants from "../../store/services/StoreConstants";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../../components/FormInputs/BTextInputValidated";

export default {
  name: "ResetPassword",
  components: { ValidationObserver, BTextInputValidated },
  props: {
    token: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      password: null,
      confirmPassword: null,
      redirectCount: 10,
      showResetButton: true,
      resetSuccess: false,
      resetError: false,
      passwordRegex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    };
  },
  computed: {
    ...mapGetters({ email: StoreConstants.GETTERS.USER }),
    lengthError: function() {
      return !this.password || this.password.length < 8;
    },
    regexError: function() {
      return !this.password || !this.passwordRegex.test(this.password);
    }
  },
  mounted: function() {
    this.vuexSetToken(this.token);
  },
  methods: {
    ...mapActions({ vuexSetToken: StoreConstants.ACTIONS.SET_TOKEN }),
    resetPassword: async function() {
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.resetError = false;

      return ExternalRestService.resetPassword({
        email: $comp.email,
        password: $comp.password,
        token: $comp.token
      })
        .then(() => {
          $comp.showResetButton = false;
          $comp.resetSuccess = true;
          $comp.resetError = false;
          localStorage.removeItem("session");

          (function countdown() {
            setTimeout(() => {
              $comp.redirectCount--;
              if ($comp.redirectCount > 0) {
                countdown();
              } else {
                $comp.$router.replace({ name: "Login" });
              }
            }, 1000);
          })();
        })
        .catch(error => {
          console.log(error);
          $comp.resetError = true;
        });
    }
  }
};
</script>

<style scoped>
.password_validators {
  margin-bottom: 25px;
}
</style>
